export default __webpack_public_path__ + "static/Entenda0131-73f81bed7b94b786fa1194eb25142089.jpg";